export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

// Lista delle valute del mondo
export const currencies: Currency[] = [
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "GBP", name: "British Pound", symbol: "£" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
  { code: "INR", name: "Indian Rupee", symbol: "₹" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "RUB", name: "Russian Ruble", symbol: "₽" },
  { code: "KRW", name: "South Korean Won", symbol: "₩" },
  { code: "MXN", name: "Mexican Peso", symbol: "$" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
  { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "PLN", name: "Polish Złoty", symbol: "zł" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "RON", name: "Romanian Leu", symbol: "lei" },
  { code: "BGN", name: "Bulgarian Lev", symbol: "лв" },
  { code: "HRK", name: "Croatian Kuna", symbol: "kn" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺" },
  { code: "ILS", name: "Israeli Shekel", symbol: "₪" },
  { code: "ZAR", name: "South African Rand", symbol: "R" },
  { code: "THB", name: "Thai Baht", symbol: "฿" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱" },
  { code: "VND", name: "Vietnamese Dong", symbol: "₫" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦" },
  { code: "EGP", name: "Egyptian Pound", symbol: "£" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh" },
  { code: "GHS", name: "Ghanaian Cedi", symbol: "₵" },
  { code: "UGX", name: "Ugandan Shilling", symbol: "USh" },
  { code: "TZS", name: "Tanzanian Shilling", symbol: "TSh" },
  { code: "MAD", name: "Moroccan Dirham", symbol: "د.م." },
  { code: "TND", name: "Tunisian Dinar", symbol: "د.ت" },
  { code: "JOD", name: "Jordanian Dinar", symbol: "د.ا" },
  { code: "LBP", name: "Lebanese Pound", symbol: "ل.ل" },
  { code: "SAR", name: "Saudi Riyal", symbol: "ر.س" },
  { code: "AED", name: "UAE Dirham", symbol: "د.إ" },
  { code: "QAR", name: "Qatari Riyal", symbol: "ر.ق" },
  { code: "KWD", name: "Kuwaiti Dinar", symbol: "د.ك" },
  { code: "BHD", name: "Bahraini Dinar", symbol: ".د.ب" },
  { code: "OMR", name: "Omani Rial", symbol: "ر.ع." },
  { code: "YER", name: "Yemeni Rial", symbol: "ر.ي" },
  { code: "IRR", name: "Iranian Rial", symbol: "﷼" },
  { code: "AFN", name: "Afghan Afghani", symbol: "؋" },
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳" },
  { code: "LKR", name: "Sri Lankan Rupee", symbol: "Rs" },
  { code: "NPR", name: "Nepalese Rupee", symbol: "₨" },
  { code: "MMK", name: "Myanmar Kyat", symbol: "K" },
  { code: "LAK", name: "Lao Kip", symbol: "₭" },
  { code: "KHR", name: "Cambodian Riel", symbol: "៛" },
  { code: "MNT", name: "Mongolian Tögrög", symbol: "₮" },
  { code: "UZS", name: "Uzbekistani Som", symbol: "so'm" },
  { code: "KZT", name: "Kazakhstani Tenge", symbol: "₸" },
  { code: "GEL", name: "Georgian Lari", symbol: "₾" },
  { code: "AMD", name: "Armenian Dram", symbol: "֏" },
  { code: "AZN", name: "Azerbaijani Manat", symbol: "₼" },
  { code: "BYN", name: "Belarusian Ruble", symbol: "Br" },
  { code: "MDL", name: "Moldovan Leu", symbol: "L" },
  { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴" },
  { code: "RSD", name: "Serbian Dinar", symbol: "дин." },
  { code: "BAM", name: "Bosnia-Herzegovina Convertible Mark", symbol: "KM" },
  { code: "MKD", name: "Macedonian Denar", symbol: "ден" },
  { code: "ALL", name: "Albanian Lek", symbol: "L" },
  { code: "ISK", name: "Icelandic Króna", symbol: "kr" },
  { code: "FJD", name: "Fijian Dollar", symbol: "$" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "$" },
  { code: "PEN", name: "Peruvian Sol", symbol: "S/" },
  { code: "CLP", name: "Chilean Peso", symbol: "$" },
  { code: "COP", name: "Colombian Peso", symbol: "$" },
  { code: "ARS", name: "Argentine Peso", symbol: "$" },
  { code: "UYU", name: "Uruguayan Peso", symbol: "$" },
  { code: "PYG", name: "Paraguayan Guaraní", symbol: "₲" },
  { code: "BOB", name: "Bolivian Boliviano", symbol: "Bs" },
  { code: "GTQ", name: "Guatemalan Quetzal", symbol: "Q" },
  { code: "HNL", name: "Honduran Lempira", symbol: "L" },
  { code: "NIO", name: "Nicaraguan Córdoba", symbol: "C$" },
  { code: "CRC", name: "Costa Rican Colón", symbol: "₡" },
  { code: "PAB", name: "Panamanian Balboa", symbol: "B/." },
  { code: "DOP", name: "Dominican Peso", symbol: "$" },
  { code: "JMD", name: "Jamaican Dollar", symbol: "$" },
  { code: "TTD", name: "Trinidad and Tobago Dollar", symbol: "$" },
  { code: "BBD", name: "Barbadian Dollar", symbol: "$" },
  { code: "XCD", name: "East Caribbean Dollar", symbol: "$" },
  { code: "BZD", name: "Belize Dollar", symbol: "$" },
  { code: "GYD", name: "Guyanese Dollar", symbol: "$" },
  { code: "SRD", name: "Surinamese Dollar", symbol: "$" },
  { code: "BMD", name: "Bermudian Dollar", symbol: "$" },
  { code: "KYD", name: "Cayman Islands Dollar", symbol: "$" },
  { code: "ANG", name: "Netherlands Antillean Guilder", symbol: "ƒ" },
  { code: "AWG", name: "Aruban Florin", symbol: "ƒ" },
  { code: "BSD", name: "Bahamian Dollar", symbol: "$" },
  { code: "HTG", name: "Haitian Gourde", symbol: "G" },
  { code: "CUP", name: "Cuban Peso", symbol: "$" },
  { code: "CUC", name: "Cuban Convertible Peso", symbol: "$" },
  { code: "ERN", name: "Eritrean Nakfa", symbol: "Nfk" },
  { code: "ETB", name: "Ethiopian Birr", symbol: "Br" },
  { code: "DJF", name: "Djiboutian Franc", symbol: "Fdj" },
  { code: "SOS", name: "Somali Shilling", symbol: "Sh" },
  { code: "SLL", name: "Sierra Leonean Leone", symbol: "Le" },
  { code: "GMD", name: "Gambian Dalasi", symbol: "D" },
  { code: "GNF", name: "Guinean Franc", symbol: "FG" },
  { code: "LRD", name: "Liberian Dollar", symbol: "$" },
  { code: "CVE", name: "Cape Verdean Escudo", symbol: "$" },
  { code: "STD", name: "São Tomé and Príncipe Dobra", symbol: "Db" },
  { code: "XOF", name: "West African CFA Franc", symbol: "CFA" },
  { code: "XAF", name: "Central African CFA Franc", symbol: "FCFA" },
  { code: "XPF", name: "CFP Franc", symbol: "₣" },
  { code: "WST", name: "Samoan Tālā", symbol: "T" },
  { code: "TOP", name: "Tongan Paʻanga", symbol: "T$" },
  { code: "VUV", name: "Vanuatu Vatu", symbol: "Vt" },
  { code: "SBD", name: "Solomon Islands Dollar", symbol: "$" },
  { code: "PGK", name: "Papua New Guinean Kina", symbol: "K" },
  { code: "KID", name: "Kiribati Dollar", symbol: "$" },
  { code: "TVD", name: "Tuvaluan Dollar", symbol: "$" },
  { code: "SVC", name: "Salvadoran Colón", symbol: "₡" },
  { code: "BWP", name: "Botswana Pula", symbol: "P" },
  { code: "NAD", name: "Namibian Dollar", symbol: "$" },
  { code: "LSL", name: "Lesotho Loti", symbol: "L" },
  { code: "SZL", name: "Eswatini Lilangeni", symbol: "L" },
  { code: "MZN", name: "Mozambican Metical", symbol: "MT" },
  { code: "MWK", name: "Malawian Kwacha", symbol: "MK" },
  { code: "ZMW", name: "Zambian Kwacha", symbol: "ZK" },
  { code: "ZWL", name: "Zimbabwean Dollar", symbol: "$" },
  { code: "AOA", name: "Angolan Kwanza", symbol: "Kz" },
  { code: "MGA", name: "Malagasy Ariary", symbol: "Ar" },
  { code: "MUR", name: "Mauritian Rupee", symbol: "₨" },
  { code: "SCR", name: "Seychellois Rupee", symbol: "₨" },
  { code: "KMF", name: "Comorian Franc", symbol: "CF" },
  { code: "MVR", name: "Maldivian Rufiyaa", symbol: "Rf" },
  { code: "BTN", name: "Bhutanese Ngultrum", symbol: "Nu." },
  { code: "MOP", name: "Macanese Pataca", symbol: "MOP$" },
  { code: "TWD", name: "New Taiwan Dollar", symbol: "NT$" },
  { code: "BND", name: "Brunei Dollar", symbol: "$" }
];

// Funzione di utilità per trovare una valuta per codice
export const findCurrencyByCode = (code: string): Currency | undefined => {
  return currencies.find(currency => currency.code === code);
};

// Funzione di utilità per ottenere la valuta di default
export const getDefaultCurrency = (): Currency => {
  return findCurrencyByCode("EUR") || currencies[0];
};

// Funzione di utilità per filtrare le valute per ricerca
export const filterCurrencies = (searchTerm: string): Currency[] => {
  const term = searchTerm.toLowerCase();
  return currencies.filter(currency => 
    currency.code.toLowerCase().includes(term) ||
    currency.name.toLowerCase().includes(term) ||
    currency.symbol.toLowerCase().includes(term)
  );
};
